import { render, staticRenderFns } from "./add-brand-modal.vue?vue&type=template&id=bbe8a9b2"
import script from "./add-brand-modal.vue?vue&type=script&lang=js"
export * from "./add-brand-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports